import { PropsWithChildren } from 'react';

const Status = ({ children }: PropsWithChildren) => (
  <div className="bg-white text-s-m! py-1 px-3 rounded-xl w-fit">{children}</div>
);

type LogisticsStatusProps = {
  routeStatus?: string;
  quoteStatus?: string;
};

export const LogisticsStatus = ({ routeStatus, quoteStatus }: LogisticsStatusProps) => {
  if (!routeStatus && !quoteStatus) return null;

  return (
    <div>
      <div className="text-s-cps text-base-30 mb-3">Logistics Status</div>
      <div className="flex flex-col gap-3">
        {routeStatus && <Status>{routeStatus}</Status>}
        {quoteStatus && <Status>{quoteStatus}</Status>}
      </div>
    </div>
  );
};
